import { FunctionComponent } from 'react'
import { AppAvatar, AppRow, AppCol, AppSkeleton } from '@/shared/ui'

import { PhoneIcon, TruckIcon, DeviceMobileIcon, CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react'

export type ResourceProfileProps = {
  lastUpdatePosition?: string
  name?: string
  email?: string
  phoneNumber?: string
  photoUrl?: string
  createdAt?: string
  vehicleType?: string
  wantsToReceiveTasks?: boolean
  shopperAppVersion?: string
  loading?: boolean
  className?: string
}

export const ResourceProfileInfo: FunctionComponent<ResourceProfileProps> = ({
  lastUpdatePosition = '',
  name = '',
  email = '',
  phoneNumber = '',
  photoUrl = '',
  createdAt = '',
  vehicleType = '',
  wantsToReceiveTasks = false,
  shopperAppVersion = '',
  loading = false,
  className = ''
}: ResourceProfileProps): JSX.Element => {
  return (
    <div data-testid='gungnir-rpi' className={`gungnir-rpi ${className}`}>
      <AppSkeleton loading={loading} avatar active>
        <AppRow gutter={18}>
          <AppCol span={4}>
            <div className='gungnir-rpi-image-container'>
              <AppAvatar
                className='gungnir-rpi-image'
                src={photoUrl}
                shape='circle'
                size={{ xs: 72, sm: 72, md: 72, lg: 72, xl: 80, xxl: 100 }}
              />
              <div className='gungnir-rpi-sticker'>
                {wantsToReceiveTasks ? (
                  <CheckCircleIcon weight='fill' size={20} color='#29a829' />
                ) : (
                  <XCircleIcon weight='fill' size={20} color='#ec5b5e' />
                )}
              </div>
            </div>
          </AppCol>
          <AppCol className='gungnir-rpi-data-container' span={13}>
            <div data-testid='gungnir-rpi-last-update-position' className='gungnir-rpi-normal-text'>
              {lastUpdatePosition}
            </div>
            <div data-testid='gungnir-rpi-name' className='gungnir-rpi-name'>
              {name}
            </div>
            <div data-testid='gungnir-rpi-email' className='gungnir-rpi-email'>
              {email}
            </div>
            <div data-testid='gungnir-rpi-created-at' className='gungnir-rpi-normal-text'>
              {createdAt}
            </div>
          </AppCol>
          <AppCol className='gungnir-rpi-data-container' span={6}>
            <div className='gungnir-rpi-normal-bold-text'>
              <PhoneIcon /> {phoneNumber}
            </div>
            <div className='gungnir-rpi-normal-bold-text'>
              <TruckIcon /> {vehicleType}
            </div>
            <div className='gungnir-rpi-normal-bold-text'>
              <DeviceMobileIcon /> {shopperAppVersion}
            </div>
          </AppCol>
        </AppRow>
      </AppSkeleton>
    </div>
  )
}
